/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DataBase Common API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { ApiResponseDbInstanceMetaResponse, GetDbInstanceMetaParams } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 전체 인스턴스 메타 정보 제공 - 폴더별 트리 구조 (폴더 정보: id, name, dbType / 인스턴스 정보: id, name, enabled, dbmsType, dbmsVersion, alias)
 * @summary DB 인스턴스 메타 정보
 */
export const getDbInstanceMeta = (
  params?: MaybeRef<GetDbInstanceMetaParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseDbInstanceMetaResponse>(
    { url: `/api/db-instance-meta`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetDbInstanceMetaQueryKey = (params?: MaybeRef<GetDbInstanceMetaParams>) => {
  return ['api', 'db-instance-meta', ...(params ? [params] : [])] as const;
};

export const getGetDbInstanceMetaQueryOptions = <
  TData = Awaited<ReturnType<typeof getDbInstanceMeta>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetDbInstanceMetaParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDbInstanceMeta>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetDbInstanceMetaQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDbInstanceMeta>>> = ({ signal }) =>
    getDbInstanceMeta(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDbInstanceMeta>>,
    TError,
    TData
  >;
};

export type GetDbInstanceMetaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDbInstanceMeta>>
>;
export type GetDbInstanceMetaQueryError = ErrorType<unknown>;

/**
 * @summary DB 인스턴스 메타 정보
 */

export function useGetDbInstanceMeta<
  TData = Awaited<ReturnType<typeof getDbInstanceMeta>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetDbInstanceMetaParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDbInstanceMeta>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDbInstanceMetaQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
